export default __webpack_public_path__ + "static/media/aboutHz.b72f4eee.png";